import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReplenishmentLetdownDetailPageRBAC = {
  pageID: 'dc3e17446848758ed622eb4ee77f117c',
  elementID: {
    ViewPage: 'eab318f05a45d06a10adaf6931f9b092',
    ActionCancelReplenish: '1c0ae62111cb301bc0b64e34e535e4f0',
    ActionAssignHelper: '3accff820a6d533cc59e61f084bf1659',
    ActionChangeHelper: '2030bfa7a29424cb4d06c3c88f96a592',
  },
} as const

export const useRBACReplenishmentLetdownDetailPage = createUseRBAC(
  ReplenishmentLetdownDetailPageRBAC.elementID,
)

export type UseRBACReplenishmentLetdownDetailPageType = ReturnType<
  typeof useRBACReplenishmentLetdownDetailPage
>

export const ReplenishmentPutawayDetailPageRBAC = {
  pageID: 'ca1eb08ada9474d4daa9fd54497cc152',
  elementID: {
    ViewPage: 'e29ebccae9354dba4b9785ecec72a837',
    ActionDeletePIC: 'fdc2427025a82beec0e229d936dea01f',
  },
} as const

export const useRBACReplenishmentPutawayDetailPage = createUseRBAC(
  ReplenishmentPutawayDetailPageRBAC.elementID,
)

export type UseRBACReplenishmentPutawayDetailPageType = ReturnType<
  typeof useRBACReplenishmentPutawayDetailPage
>
